import { AppNS } from 'app';
import {
  DISCIPLINES,
  getTypeById,
} from 'app/main/agency/profile/qualifications-sections/sections/disciplines-picker/validation-schema';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import BasicSelect from 'app/ui_v2/form-fields/basic-fields/select/BasicSelect';

import { useQuery } from '@tanstack/react-query';

import { getDisciplinesValues } from '../helpers';

export interface DisciplinesSelectProps {
  control: any;
  subject: string | null;
  subjectType: AppNS.SubjectType | '';
}

const getDisciplinesForList = (allowed: { id: string; name: string }[]): AppNS.Params[] => {
  let current = '';

  const allowedDisciplineIds = allowed.map((item) => item.name);
  return DISCIPLINES.filter((discipline) => allowedDisciplineIds.includes(discipline.id)).reduce(
    (acc: AppNS.Params[], discipline) => {
      const type = getTypeById(discipline.parent);
      if (current !== discipline.parent) {
        acc.push({ id: 'optgroup', name: type?.name || '' });
        current = discipline.parent;
      }
      acc.push({
        ...discipline,
        id:
          allowed.find((d) => {
            return discipline.id === d.name;
          })?.id || '',
      });
      return acc;
    },
    []
  );
};

export default function DisciplinesSelect(props: DisciplinesSelectProps) {
  const { control, subject, subjectType } = props;

  const queryKey = ['get-disciplines-autocomplete', subject];

  const { isFetching, isError, error, data } = useQuery({
    queryKey,
    queryFn: ({ signal }) => getDisciplinesValues(subject || '', subjectType, signal),
    enabled: Boolean(subject) && subjectType !== '',
  });

  return (
    <>
      <BasicSelect
        collection={getDisciplinesForList(data || [])}
        isLoading={isFetching}
        label="Discipline for deactivation"
        inputName={'disciplineForDeactivationId'}
        control={control}
        disabled={!subject}
      />
      {isError && error && <ErrorsList title="Unexpected loading error" errors={error as string[]} />}
    </>
  );
}
